//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function (module) {

    //Use strict mode
    'use strict';

    //==========================================
    // CLASS GOOGLEGEOCODER
    //==========================================

    /**
     * @class am.GoogleGeocoder
     * Helper class used to get the address from coordinates (or vice versa)
     */
    module.GoogleGeocoder = function () {
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} config - Configuration file
     */
    module.GoogleGeocoder.prototype.init = function (config) {
        this._oGeocoder = new google.maps.Geocoder(); // Reference to the Google object performing the geocoding
    };

    /**
     * Class destructor
     */
    module.GoogleGeocoder.prototype.destroy = function () {
        delete this._oGeocoder;
    };

    module.GoogleGeocoder.prototype.getType = function () {
        return "Google";
    };

    module.GoogleGeocoder.prototype.geocode = function (oPrm, fnCallback) {
        return this._oGeocoder.geocode(oPrm, function (oRes, oStatus) {
            return fnCallback(oRes, oStatus);
        });
    };

    /**
     * Returns the postal address of the point whose coordinates are passed as input arguments
     *
     * @param {Object} oCoords - Coordinates of the point whose address is to be returned. The coordinates must be
     *          specified as an object with two keys: 'lat' and 'lng', or as an array [lat, lng]
     * @returns {Promise} Promise evaluating to the postal address of the input point, returned as an object with the
     *          following keys:
     *              - formattedAddress
     *              - streetNumber
     *              - streetName
     *              - cityName
     *              - postalCode
     *              - country
     */
    module.GoogleGeocoder.prototype.getPostalAddressFromPosition = function (oCoords) {
        var self = this;
        if (Array.isArray(oCoords)) {
            oCoords = {lat: oCoords[0], lng: oCoords[1]};
        }
        return new Promise(function (resolve, reject) {
            self._oGeocoder.geocode({location: oCoords}, function (oResultsA, sStatus) { // caution: sResultsA can be null if status == 'OVER_QUERY_LIMIT'
                if (sStatus === "OK" && oResultsA[0].types.indexOf('country') === -1) { // HACK: in case a country was specified to restrict the search, Google returns this country if no matching address was found
                    var returnedVariable = {formattedAddress: oResultsA[0].formatted_address};
                    oResultsA[0].address_components.forEach(function (component) {
                        if (component.types.indexOf("street_number") !== -1) {
                            returnedVariable.streetNumber = component.long_name;
                        } else if (component.types.indexOf("route") !== -1) {
                            returnedVariable.streetName = component.long_name;
                        } else if (component.types.indexOf("locality") !== -1) {
                            returnedVariable.cityName = component.long_name;
                        } else if (component.types.indexOf("postal_code") !== -1) {
                            returnedVariable.postalCode = component.long_name;
                        } else if (component.types.indexOf("country") !== -1) {
                            returnedVariable.country = component.long_name;
                        }
                    });
                    resolve(returnedVariable);
                } else if (sStatus !== 'OVER_QUERY_LIMIT') {
                    resolve(am.translator.translate("Unknown address"));
                } else {
                    reject("Cannot get postal address of point " + am.translator.formatNumber(oCoords.lat, 2) + "N " +
                        am.translator.formatNumber(oCoords.lng, 2) + "E: " + sStatus);
                }
            });
        });
    };

    /**
     * Returns the geographical position of the postal address passed as input argument
     *
     * @param {String} sAddress - Postal address of the point whose coordinates are to be returned
     * @returns {Promise} Promise evaluating to the coordinates of the input point, returned as an object with two
     *      keys: 'lat' and 'lng'
     */
    module.GoogleGeocoder.prototype.getPositionFromPostalAddress = function (sAddress) {
        // TODO
        return Promise.resolve("350 route de la Traverse, 73000 Montagnole, France");
    };

    /**
     * Returns a list of suggestions for the incomplete address passed as input argument
     *
     * @param {String} sAddress - Address to be completed
     * @param {Number} iNumSuggestions - Maximum number of suggestions to be returned (defaults to 5)
     * @returns {Promise} Promise evaluating to the list of complete addresses corresponding to the incomplete address
     *      passed as input argument. The list of suggestions is returned by the promise as an array of strings.
     */
    module.GoogleGeocoder.prototype.getPostalAddressSuggestions = function (sAddress, iNumSuggestions) {
        iNumSuggestions = (iNumSuggestions === undefined) ? 5 : iNumSuggestions;
        // TODO
        return Promise.resolve(["350 route de la Traverse, 73000 Montagnole, France"]);
    };

    //==========================================
    // CLASS BASEADRESSENATIONALEGEOCODER
    //==========================================

    /**
     * @class am.BaseAdresseNationaleGeocoder
     * Helper class used to get the address from coordinates (or vice versa)
     */
    module.BaseAdresseNationaleGeocoder = function () {
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} config - Configuration file
     */
    module.BaseAdresseNationaleGeocoder.prototype.init = function (config) {
        this._singleGeocodingRequestUrl = "https://api-adresse.data.gouv.fr/search/";
        this._multipleGeocodingRequestUrl = "https://api-adresse.data.gouv.fr/search/csv/";
        this._singleReverseRequestUrl = "https://api-adresse.data.gouv.fr/reverse/";
        this._multipleReverseRequestUrl = "https://api-adresse.data.gouv.fr/reverse/csv/";
        this._searchZoneCenterPoint = config.mapOptions.center.slice();
        if (config.mapOptions.hasOwnProperty('maxBounds')) {
            this._searchZoneCenterPoint[0] = 0.5 * (config.mapOptions.maxBounds.lowerLeftCorner[0] + config.mapOptions.maxBounds.upperRightCorner[0]);
            this._searchZoneCenterPoint[1] = 0.5 * (config.mapOptions.maxBounds.lowerLeftCorner[1] + config.mapOptions.maxBounds.upperRightCorner[1]);
        }
    };

    /**
     * Class destructor
     */
    module.BaseAdresseNationaleGeocoder.prototype.destroy = function () {
    };

    module.BaseAdresseNationaleGeocoder.prototype.getType = function () {
        return "BaseAdresse";
    };

    module.BaseAdresseNationaleGeocoder.prototype.geocode = function (oPrm, fnCallback) {
        return fnCallback([{types: []}], "ZERO_RESULTS");
    };

    /**
     * Returns the postal address of the point whose coordinates are passed as input arguments
     *
     * @param {Object} oCoords - Coordinates of the point whose address is to be returned. The coordinates must be
     *          specified as an object with two keys: 'lat' and 'lng', or as an array [lat, lng]
     * @returns {Promise} Promise evaluating to the postal address of the input point, returned as an object with the
     *          following keys:
     *              - formattedAddress
     *              - streetNumber
     *              - streetName
     *              - cityName
     *              - postalCode
     *              - country
     */
    module.BaseAdresseNationaleGeocoder.prototype.getPostalAddressFromPosition = function (oCoords) {
        var self = this;
        var lat = Array.isArray(oCoords) ? oCoords[0] : oCoords.lat;
        var lng = Array.isArray(oCoords) ? oCoords[1] : oCoords.lng;
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: 'GET',
                url: self._singleReverseRequestUrl,
                data: {
                    lat: lat,
                    lon: lng
                },
                dataType: 'json',
                error: function (uselessParameter, msg) {
                    reject("Cannot get postal address of point " + am.translator.formatNumber(lat, 2) + "N " +
                        am.translator.formatNumber(lng, 2) + "E: " + msg);
                },
                success: function (responseData) {
                    if (responseData.hasOwnProperty('features') && responseData.features.length > 0) {
                        // Sort features by score index (descending order)
                        var features = responseData.features;
                        features.sort(function (a, b) {
                            return b.properties.score - a.properties.score;
                        });

                        // Parse answer
                        var bestFeature = features[0].properties;
                        if(!bestFeature.hasOwnProperty("housenumber")){
                            bestFeature.housenumber = "";
                        }
                        resolve({
                            formattedAddress: bestFeature.label,
                            streetNumber: bestFeature.housenumber,
                            streetName: bestFeature.name.replace(new RegExp('^' + bestFeature.housenumber.replace(/\s/g, '\\s') + '\\s+', 'i'), ''),
                            cityName: bestFeature.city,
                            postalCode: bestFeature.postcode,
                            country: "France"
                        });
                    } else {
                        resolve(am.translator.translate("Unknown address"));
                    }
                }
            });
        });
    };

    /**
     * Returns the postal addresses of the points whose coordinates are passed as input arguments
     *
     * @param {Object[]} oCoordsA - Coordinates of the points whose addresses are to be returned. The coordinates must
     *          be specified as an object with two keys: 'lat' and 'lng', or as an array [lat, lng]
     * @returns {Promise} Promise evaluating to the postal addresses of the input points, returned as an array of objects
     *          with the following keys:
     *              - formattedAddress
     *              - streetNumber
     *              - streetName
     *              - cityName
     *              - postalCode
     *              - country
     */
    module.BaseAdresseNationaleGeocoder.prototype.getPostalAddressesFromPositions = function (oCoordsA) {
        var self = this;

        // Write coordinates in a CSV file
        var csvString = "latitude;longitude";
        oCoordsA.forEach(function (point) {
            if (Array.isArray(point)) {
                csvString += "\n" + point[0] + ";" + point[1];
            } else {
                csvString += "\n" + point.lat + ";" + point.lng;
            }
        });
        var csvFile = new Blob([csvString], {type: 'text/plain'});

        // Create the FormData object
        var formData = new FormData();
        formData.append('data', csvFile);

        // Query the Base Adresse Nationale and return the result
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: self._multipleReverseRequestUrl,
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'text',
                type: 'POST',
                error: function (uselessParameter, msg) {
                    reject("Cannot get postal addresses of the given points: " + msg);
                },
                success: function (responseData) {
                    var parsedResponse = self._parseCsv(responseData);
                    var featureInfos = parsedResponse.map(function (feature) {
                        return {
                            formattedAddress: feature.result_label,
                            streetNumber: feature.result_housenumber,
                            streetName: feature.result_name.replace(new RegExp('^' + feature.result_housenumber.replace(/\s/g, '\\s') + '\\s+', 'i'), ''),
                            cityName: feature.result_city,
                            postalCode: feature.result_postcode,
                            country: "France"
                        };
                    });
                    resolve(featureInfos);
                }
            });
        });
    };

    /**
     * Returns the geographical position of the postal address passed as input argument
     *
     * @param {String} sAddress - Postal address of the point whose coordinates are to be returned
     * @returns {Promise} Promise evaluating to the coordinates of the input point, returned as an object with two
     *      keys: 'lat' and 'lng'
     */
    module.BaseAdresseNationaleGeocoder.prototype.getPositionFromPostalAddress = function (sAddress) {
        var self = this;
        var queriedAddress = sAddress.replace(/\s+/g, '\+');
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: 'GET',
                url: self._singleGeocodingRequestUrl,
                data: {
                    q: queriedAddress,
                    limit: 1
                },
                dataType: 'json',
                error: function (uselessParameter, msg) {
                    reject("Cannot get geographical coordinates of address '" + sAddress + "': " + msg);
                },
                success: function (responseData) {
                    if (responseData.hasOwnProperty('features') && responseData.features.length > 0) {
                        var coordinates = responseData.features[0].geometry.coordinates;
                        resolve({
                            lat: coordinates[1],
                            lng: coordinates[0]
                        });
                    } else {
                        resolve({
                            lat: undefined,
                            lng: undefined
                        });
                    }
                }
            });
        });
    };

    /**
     * Returns the geographical positions of the postal addresses passed as input arguments
     *
     * @param {String[]} sAddresses - Postal addresses of the points whose coordinates are to be returned
     * @returns {Promise} Promise evaluating to the coordinates of the input points, returned as an array of object with
     *      two keys: 'lat' and 'lng'
     */
    module.BaseAdresseNationaleGeocoder.prototype.getPositionsFromPostalAddresses = function (sAddresses) {
        var self = this;
        if (!Array.isArray(sAddresses) || sAddresses.length === 0) {
            return [];
        }

        // Ecriture des adresses dans un fichier CSV. Le nombre de colonnes est ajusté en fonction
        // des adresses entrées : on tente de deviner si les adresses proviennent d'une concaténation
        // de colonnes ou non, et si oui, on essaie de deviner laquelle contient le code postal.
        var separator = sAddresses[0].indexOf(';') !== -1 ? ';' :
                        sAddresses[0].indexOf(',') !== -1 ? ',' :
                        sAddresses[0].indexOf('\t') !== -1 ? '\t' :
                        undefined;
        var header = ['address'];
        var iPostCodeColumn = undefined;
        if (separator !== undefined) {
            var addressParts = sAddresses[0].split(separator);
            header = addressParts.map(function(part, iCol) {
                if (part.search(/^\s*\d{4,5}\s*$/) !== -1) {
                    iPostCodeColumn = iCol;
                }
                return 'column_' + iCol;
            });
        }
        var csvString = header.join(separator) + '\n' + sAddresses.join('\n');
        var csvFile = new Blob([csvString], {type: 'text/plain'});

        // Create the FormData object
        var formData = new FormData();
        formData.append('data', csvFile);
        if (iPostCodeColumn !== undefined) {
            formData.append('postcode', header[iPostCodeColumn]);
        }

        // Query the Base Adresse Nationale and return the result
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: self._multipleGeocodingRequestUrl,
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'text',
                type: 'POST',
                error: function (uselessParameter, msg) {
                    reject("Cannot get geographical coordinates of the given addresses: " + msg);
                },
                success: function (responseData) {
                    var parsedResponse = self._parseCsv(responseData);
                    var featureInfos = parsedResponse.map(function (feature) {
                        return {
                            lat: feature.latitude,
                            lng: feature.longitude
                        };
                    });
                    resolve(featureInfos);
                }
            });
        });
    };

    /**
     * Returns a list of suggestions for the incomplete address passed as input argument
     *
     * @param {String} sAddress - Address to be completed
     * @param {Number} iNumSuggestions - Maximum number of suggestions to be returned (defaults to 5)
     * @returns {Promise} Promise evaluating to the list of complete addresses corresponding to the incomplete address
     *      passed as input argument. The list of suggestions is returned by the promise as an array of strings.
     */
    module.BaseAdresseNationaleGeocoder.prototype.getPostalAddressSuggestions = function (sAddress, iNumSuggestions) {
        var self = this;
        var nSuggestions = (iNumSuggestions === undefined) ? 5 : iNumSuggestions;
        var queriedAddress = sAddress.replace(/\s+/g, '\+');
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: 'GET',
                url: self._singleGeocodingRequestUrl,
                data: {
                    q: queriedAddress,
                    lat: self._searchZoneCenterPoint[0],
                    lon: self._searchZoneCenterPoint[1],
                    limit: nSuggestions
                },
                dataType: 'json',
                error: function (uselessParameter, msg) {
                    reject("Cannot get completion suggestions for incomplete address '" + sAddress + "': " + msg);
                },
                success: function (responseData) {
                    if (responseData.hasOwnProperty('features') && responseData.features.length > 0) {
                        // Sort features by score index (descending order)
                        var features = responseData.features;
                        features.sort(function (a, b) {
                            return b.properties.score - a.properties.score;
                        });

                        // Parse answer
                        resolve(features.map(function (feature) {
                            return feature.properties.label;
                        }));
                    } else {
                        resolve([]);
                    }
                }
            });
        });
    };

    /**
     * Parses the lines of the CSV file returned by the API and outputs the result as an array of Objects (one object
     * per line, the keys of each object correspond to the columns of the CSV file)
     * @param csvContents
     * @returns {Array}
     * @private
     */
    module.BaseAdresseNationaleGeocoder.prototype._parseCsv = function (csvContents) {
        var output = [];
        var lines = csvContents.replace(/(^\s+)|(\s+$)/g, '').split('\n');
        if (lines.length > 0) {
            var headerLine = lines.splice(0, 1)[0].trim(); // strip off first line

            // Define the function used to parse each line
            var parseLine = undefined;
            if (headerLine[0] !== '"' && headerLine.indexOf(';') !== -1) {
                parseLine = function (line) {
                    return line.split(';');
                };
            } else if (headerLine[0] === '"' && headerLine.indexOf(',') !== -1) {
                parseLine = function (line) {
                    return JSON.parse("[" + line + "]");
                };
            } else {
                var separator = headerLine.indexOf(';') !== -1 ? ';' :
                                headerLine.indexOf(',') !== -1 ? ',' :
                                headerLine.indexOf('\r') !== -1 ? '\r' :
                                '\t';
                parseLine = function (line) {
                    var values = [];
                    var quoteChar = '"';
                    var currItem = '';
                    line.trim().split(separator).forEach(function(item) {
                        if (item.length > 0 && item[0] === quoteChar) {
                            currItem = item.substring(1);
                        } else if (currItem.length > 0) {
                            currItem += separator + item;
                            if (currItem[currItem.length - 1] === quoteChar) {
                                values.push(currItem.substring(0, currItem.length - 1));
                                currItem = '';
                            }
                        } else {
                            values.push(item);
                        }
                    });
                    return values;
                };
            }

            // Parse the file lines
            var columnNames = parseLine(headerLine);
            lines.forEach(function (line) {
                var columnValues = parseLine(line);
                if (columnValues.length === columnNames.length) {
                    var obj = {};
                    columnValues.forEach(function (value, index) {
                        obj[columnNames[index]] = isNaN(value) ? value : parseFloat(value);
                    });
                    output.push(obj);
                } else {
                    output.push(undefined);
                }
            });
        }
        return output;
    };


    //==========================================
    // CLASS GEOPORTAILGEOCODER
    //==========================================

    module.GeoportailGeocoder = function () {
    };

    module.GeoportailGeocoder.prototype.init = function (config) {
        this._sApiUser = "cythelia";
        this._sApiPwd = null;
        this._sApiKey = "h7swtfyekj05708npgj86ixw";

        this._singleGeocodingRequestUrl =
            "https://" +
            (
                (this._sApiUser && this._sApiPwd) ?
                    (this._sApiUser + ":" + this._sApiPwd + "@") :
                    ""
            ) + "wxs.ign.fr/" + this._sApiKey + "/geoportail/ols";

        this._singleReverseRequestUrl = "https://" +
            (
                (this._sApiUser && this._sApiPwd) ?
                    (this._sApiUser + ":" + this._sApiPwd + "@") :
                    ""
            ) + "wxs.ign.fr/" + this._sApiKey + "/ols/apis/completion";
    };

    module.GeoportailGeocoder.prototype.destroy = function () {
    };

    module.GeoportailGeocoder.prototype.getType = function () {
        return "Geoportail";
    };

    module.GeoportailGeocoder.prototype.getPostalAddressFromPosition = function (oCoords, fnCallback) {
        var self = this,
            fLat = (Array.isArray(oCoords) ? oCoords[0] : oCoords.lat),
            fLng = Array.isArray(oCoords) ? oCoords[1] : oCoords.lng,
            sXml = '<?xml version="1.0" encoding="UTF-8"?>' +
                '<XLS version="1.2"' +
                '  xmlns="http://www.opengis.net/xls"' +
                '  xmlns:gml="http://www.opengis.net/gml"' +
                '  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"' +
                '  xsi:schemaLocation="http://www.opengis.net/xls http://schemas.opengis.net/ols/1.2/olsAll.xsd">' +
                '    <RequestHeader/>' +
                '    <Request methodName="ReverseGeocodeRequest" maximumResponses="10" requestID="abc" version="1.2">' +
                '       <ReverseGeocodeRequest>' +
                '          <ReverseGeocodePreference>StreetAddress</ReverseGeocodePreference>' +
                '          <Position>' +
                '             <gml:Point>' +
                '                <gml:pos>' + fLat.toString() + ' ' + fLng.toString() + '</gml:pos>' +
                '             </gml:Point>' +
                '          </Position>' +
                '       </ReverseGeocodeRequest>' +
                '  </Request>' +
                '</XLS>';

        $.ajax({
            type: 'GET',
            url: this._singleGeocodingRequestUrl + "?xls=" + encodeURI(sXml),
            error: function (o, sMsg) {
                console.log(sMsg + ": " + o.responseText);
                return fnCallback([{types: []}], "ZERO_RESULTS");
            },
            success: function (oData) {
                console.log(oData);
                var oMatch = {type: []}, sStatus = "ZERO_RESULTS";
                if (oData) {
                    var oAddressA = [], oXmlPropA = $(oData).find("ReverseGeocodedLocation");
                    oXmlPropA.each(function () {
                        var oPlace = {}, oPlaceType = {};
                        oPlace.point = $(this).find('gml\\:pos').text().split(' ');
                        oPlace.building_number = "";
                        if ($(this).find('Building') && $(this).find('Building').attr("number")) {
                            oPlace.building_number = $(this).find('Building').attr("number");
                        }
                        oPlace.street = $(this).find('Street').text();
                        $(this).find('Place').each(function () {
                            oPlaceType[$(this).attr('type')] = $(this).text();
                        });
                        oPlace.municipality = oPlaceType["Municipality"];
                        oPlace.territory = oPlaceType["Territoire"];
                        oPlace.quality = oPlaceType["Qualite"];
                        oPlace.boundings = oPlaceType["Bbox"].split(';');
                        oPlace.id_tr = oPlaceType["ID_TR"];
                        oPlace.departement = oPlaceType["Departement"];
                        oPlace.city = oPlaceType["Commune"];
                        oPlace.postal_code = parseInt($(this).find('PostalCode').text());
                        oPlace.address =
                            (oPlace.building_number !== "" ? (oPlace.building_number + " ") : "") + oPlace.street + ", " + oPlace.postal_code + " " + oPlace.city;
                        oAddressA.push(oPlace);
                    });
                    if (oAddressA.length > 0) {
                        oMatch = oAddressA[0];
                        oMatch.formatted_address = oMatch.address;
                        oMatch.streetNumber = "";
                        oMatch.streetName = oMatch.street;
                        oMatch.cityName = oMatch.city;
                        oMatch.postalCode = oMatch.postal_code;
                        oMatch.country = "France";
                        oMatch.geometry = {
                            location: {
                                lat: function () {
                                    return parseFloat(oMatch.point[0]);
                                },
                                lng: function () {
                                    return parseFloat(oMatch.point[1]);
                                }
                            },
                            bounds: {
                                getSouthWest: function () {
                                    return {
                                        lat: function () {
                                            return parseFloat(oMatch.boundings[1]);
                                        },
                                        lng: function () {
                                            return parseFloat(oMatch.boundings[0]);
                                        }
                                    }
                                },
                                getNorthEast: function () {
                                    return {
                                        lat: function () {
                                            return parseFloat(oMatch.boundings[3]);
                                        },
                                        lng: function () {
                                            return parseFloat(oMatch.boundings[2]);
                                        }
                                    }
                                }
                            }
                        };
                        oMatch.types = [];
                        sStatus = "OK"
                    }
                    else {
                        sStatus = "ZERO_RESULTS";
                    }
                }
                return fnCallback([oMatch], sStatus);
            }
        });
    };

    module.GeoportailGeocoder.prototype.getPositionFromPostalAddress = function (sAddress, fnCallback) {
        var self = this, sXml = '<?xml version="1.0" encoding="UTF-8"?>' +
            '<XLS xmlns:gml="http://www.opengis.net/gml" xmlns="http://www.opengis.net/xls"' +
            ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" version="1.2"' +
            ' xsi:schemaLocation="http://www.opengis.net/xls http://schemas.opengis.net/ols/1.2/olsAll.xsd">' +
            ' <RequestHeader srsName="epsg:4326"/>' +
            ' <Request maximumResponses="5" methodName="GeocodeRequest" requestID="uid42" version="1.2">' +
            '  <GeocodeRequest returnFreeForm="false">' +
            '   <Address countryCode="StreetAddress">' +
            '    <freeFormAddress>' + sAddress + '</freeFormAddress>' +
            '   </Address>' +
            '  </GeocodeRequest>' +
            ' </Request>' +
            '</XLS>';

        $.ajax({
            type: 'GET',
            url: this._singleGeocodingRequestUrl + "?xls=" + encodeURI(sXml),
            error: function (o, sMsg) {
                console.log(sMsg + ": " + o.responseText);
                return fnCallback([{types: []}], "ZERO_RESULTS");
            },
            success: function (oData) {
                console.log(oData);
                var oMatch = {type: []}, sStatus = "ZERO_RESULTS";
                if (oData) {
                    var oGeocodedA = [], oXmlPropA = $(oData).find("GeocodedAddress");
                    oXmlPropA.each(function () {
                        var oPlace = {}, oPlaceType = {};
                        oPlace.point = $(this).find('gml\\:pos').text().split(' ');
                        $(this).find('Place').each(function () {
                            oPlaceType[$(this).attr('type')] = $(this).text();
                        });
                        oPlace.building_number = "";
                        if ($(this).find('Building') && $(this).find('Building').attr("number")) {
                            oPlace.building_number = $(this).find('Building').attr("number");
                        }
                        oPlace.street = $(this).find('Street').text();
                        oPlace.municipality = oPlaceType["Municipality"];
                        oPlace.territory = oPlaceType["Territoire"];
                        oPlace.quality = oPlaceType["Qualite"];
                        oPlace.boundings = oPlaceType["Bbox"].split(';');
                        oPlace.id_tr = oPlaceType["ID_TR"];
                        oPlace.departement = oPlaceType["Departement"];
                        oPlace.city = oPlaceType["Commune"];
                        oPlace.postal_code = parseInt($(this).find('PostalCode').text());
                        oPlace.address =
                            (oPlace.building_number !== "" ? (oPlace.building_number + " ") : "") + oPlace.street + ", " + oPlace.postal_code + " " + oPlace.city;
                        oPlace.accuracy = parseFloat($(this).find('GeocodeMatchCode').attr('accuracy'));
                        oGeocodedA.push(oPlace);
                    });
                    if (oGeocodedA.length > 0) {
                        oMatch = oGeocodedA[0];
                        oGeocodedA.forEach(function (o) {
                            if (o.accuracy > oMatch.accuracy) {
                                oMatch = o;
                            }
                        });
                        oMatch.formatted_address = oMatch.address;
                        oMatch.streetNumber = "";
                        oMatch.streetName = oMatch.street;
                        oMatch.cityName = oMatch.city;
                        oMatch.postalCode = oMatch.postal_code;
                        oMatch.country = "France";
                        oMatch.geometry = {
                            location: {
                                lat: function () {
                                    return parseFloat(oMatch.point[0]);
                                },
                                lng: function () {
                                    return parseFloat(oMatch.point[1]);
                                }
                            },
                            bounds: {
                                getSouthWest: function () {
                                    return {
                                        lat: function () {
                                            return parseFloat(oMatch.boundings[1]);
                                        },
                                        lng: function () {
                                            return parseFloat(oMatch.boundings[0]);
                                        }
                                    }
                                },
                                getNorthEast: function () {
                                    return {
                                        lat: function () {
                                            return parseFloat(oMatch.boundings[3]);
                                        },
                                        lng: function () {
                                            return parseFloat(oMatch.boundings[2]);
                                        }
                                    }
                                }
                            }
                        };
                        oMatch.types = [];
                        sStatus = "OK"
                    }
                    else {
                        sStatus = "ZERO_RESULTS";
                    }
                }
                return fnCallback([oMatch], sStatus);
            }
        });
    };

    module.GeoportailGeocoder.prototype.getPostalAddressSuggestions = function (sAddress, nMaxEntry) {
        var self = this;
        if (!nMaxEntry) {
            nMaxEntry = 5;
        }
        return new Promise(function(resolve, reject) {
            $.ajax({
                type: 'GET',
                url: self._singleReverseRequestUrl + "?text=" + encodeURI(sAddress) + "&type=StreetAddress&maximumResponses=" + nMaxEntry.toString()
            }).then(function (oData) {
                if (oData.status === "OK" && oData.results.length > 0) {
                    resolve(oData.results.map(function (o) {
                        return o.fulltext;
                    }));
                } else {
                    reject('Error while requesting address autocompletion to the IGN server');
                }
            }).fail(function() {
                reject('Error while requesting address autocompletion to the IGN server');
            });
        });
    };

    module.GeoportailGeocoder.prototype.geocode = function (oPrm, fnCallback) {
        if (oPrm.address) {
            return this.getPositionFromPostalAddress(oPrm.address, fnCallback);
        }
        else {
            return this.getPostalAddressFromPosition(oPrm.location, fnCallback);
        }
    };

    return module;

})(am || {});

//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function (module) {
    'use strict';

    module.googleGeocoder = function (config) {
        var oGeocoder = new am.GoogleGeocoder();
        oGeocoder.init(config);
        return oGeocoder;
    };

    module.baseAdresseNationaleGeocoder = function (config) {
        var oGeocoder = new am.BaseAdresseNationaleGeocoder();
        oGeocoder.init(config);
        return oGeocoder;
    };

    module.customGeocoder = function (eType, config) {
        var oGeocoder = undefined;
        switch (eType) {
            case "Google":
                oGeocoder = new am.GoogleGeocoder();
                break;
            case "BaseAdresse":
                oGeocoder = new am.BaseAdresseNationaleGeocoder();
                break;
            case "Geoportail":
                oGeocoder = new am.GeoportailGeocoder();
                break;
            default:
                break;
        }
        if (oGeocoder) {
            oGeocoder.init(config || {});
        }
        return oGeocoder;
    };

    return module;

})(am.utils || {});